import Vue from 'vue'
import Polyglot from 'vue-polyglot'
import App from './App.vue'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(Polyglot, {
  defaultLanguage: 'fr',
  languagesAvailable: ['fr', 'en']
})

Vue.locales({
  'fr': {},
  'en': {}
})

new Vue({
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js